import { render, staticRenderFns } from "./TaskPerformanceRegionMailsModalComponent.vue?vue&type=template&id=0aeaf01d&scoped=true"
import script from "./TaskPerformanceRegionMailsModalComponent.vue?vue&type=script&lang=js"
export * from "./TaskPerformanceRegionMailsModalComponent.vue?vue&type=script&lang=js"
import style0 from "./TaskPerformanceRegionMailsModalComponent.vue?vue&type=style&index=0&id=0aeaf01d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeaf01d",
  null
  
)

export default component.exports